export default __webpack_public_path__ + "static/media/logo-placeholder.6b502caa.svg";